import * as React from "react";
import { SVGProps } from "react";
function SvgUploadIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#UploadIcon_svg__a)">
        <path
          d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H20a1 1 0 0 1 1 1v3h-2V7h-7.414l-2-2H4v11.998L5.5 11h17l-2.31 9.243a1 1 0 0 1-.97.757H3Zm16.938-8H7.062l-1.5 6h12.876l1.5-6Z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="UploadIcon_svg__a">
          <path fill="#000" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgUploadIcon;
